import { render, staticRenderFns } from "./SNPInfoDoc.vue?vue&type=template&id=92414858&"
import script from "./SNPInfoDoc.vue?vue&type=script&lang=js&"
export * from "./SNPInfoDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports